import { render, staticRenderFns } from "./withdraw-details.vue?vue&type=template&id=ac9d38a2&scoped=true"
import script from "./withdraw-details.vue?vue&type=script&lang=js"
export * from "./withdraw-details.vue?vue&type=script&lang=js"
import style0 from "./withdraw-details.vue?vue&type=style&index=0&id=ac9d38a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9d38a2",
  null
  
)

export default component.exports